// Single source of truth for the logged-in user session.
// Stores { token (JWT), user } in localStorage with a 7-day soft expiry.
// The token is attached as `Authorization: Bearer <token>` by axiosInstance.

const SESSION_KEY = 'gtt_session'
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

export const getSession = () => {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const session = JSON.parse(raw)
    if (!session.token || !session.savedAt) return null
    if (Date.now() - Number(session.savedAt) > SEVEN_DAYS_MS) {
      localStorage.removeItem(SESSION_KEY)
      return null
    }
    return session
  } catch {
    return null
  }
}

export const setSession = ({ token, user = null }) => {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify({ token, user, savedAt: Date.now() }))
  } catch {}
}

export const clearSession = () => {
  try {
    localStorage.removeItem(SESSION_KEY)
  } catch {}
}

export const getToken = () => getSession()?.token || ''
export const getUser = () => getSession()?.user || null
export const getIsAdmin = () => !!getSession()?.user?.isAdmin
